import { render } from "./MiniLogin.vue?vue&type=template&id=66211384"
import script from "./MiniLogin.vue?vue&type=script&lang=js"
export * from "./MiniLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__